export const SYSTEM_MSG_RECEIVED = 'SYSTEM_MSG_RECEIVED'
export const CHANGE_LOG_RECEIVED = 'CHANGE_LOG_RECEIVED' 
export const USER_MSGS_RECEIVED = 'USER_MSGS_RECEIVED'
export const USER_MSGS_UNREAD = 'USER_MSGS_UNREAD'
export const USER_MSG_CREATED = 'USER_MSG_CREATED'
export const USER_MSG_UPDATED = 'USER_MSG_UPDATED'
